import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=414b1a1e&scoped=true"
import script from "./Crm.vue?vue&type=script&lang=ts"
export * from "./Crm.vue?vue&type=script&lang=ts"
import style0 from "./Crm.vue?vue&type=style&index=0&id=414b1a1e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414b1a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414b1a1e')) {
      api.createRecord('414b1a1e', component.options)
    } else {
      api.reload('414b1a1e', component.options)
    }
    module.hot.accept("./Crm.vue?vue&type=template&id=414b1a1e&scoped=true", function () {
      api.rerender('414b1a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Crm.vue"
export default component.exports